import { z } from 'zod';
import { Country, EnumSchema, FromSchema, ZodDate } from '@40seas/entities/common';
import { Address, AddressSchema } from '@40seas/models';

export enum StripeIdentityDocumentType {
    DrivingLicense = 'driving_license',
    IdCard = 'id_card',
    Passport = 'passport',
}

export enum StripeIdentityDocumentStatus {
    Unverified = 'unverified',
    Verified = 'verified',
}

export const StripeIdentityDocumentSchema = z.object({
    address: AddressSchema.optional(),
    dob: ZodDate.optional(),
    expirationDate: ZodDate.optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    issuedDate: ZodDate.optional(),
    issuingCountry: z.string().optional(),
    number: z.string().optional(),
    type: EnumSchema(StripeIdentityDocumentType).optional(),
    status: EnumSchema(StripeIdentityDocumentStatus).optional(),
});

export class StripeIdentityDocument extends FromSchema(StripeIdentityDocumentSchema) {
    address?: Address;
    dob?: Date;
    expirationDate?: Date;
    firstName?: string;
    lastName?: string;
    issuedDate?: Date;
    issuingCountry?: Country;
    number?: string;
    type?: StripeIdentityDocumentType;
    status?: StripeIdentityDocumentStatus;
}
